/**
 * author:Bai.Zhiming
 * date:2019-4-3
 * description:精确日期控件，从日期一直精确到秒，初次使用在创作广电广电文稿，新建串联单
 */
"use strict";
angular.module("preciseTimePickerModule", [])
    .directive("preciseTimePicker", ["$templateRequest", "$timeout", "$filter", "$q", "$compile", function($templateRequest, $timeout, $filter, $q, $compile) {
        return {
            restirct: "AE",
            replace: false,
            require: 'ngModel',
            scope: {
                time: "=ngModel"
            },
            link: function(scope, $element, $attrs) {
                initStatus();
                initData();
                /**
                 * [getStyle description] 计算控件最外层样式
                 * @return {[type]} [description]
                 */
                scope.getStyle = function() {
                    var left = $element.offset().left;
                    var top = $element.offset().top;
                    var elementHeight = $element[0].offsetHeight;
                    return {
                        top: top + elementHeight,
                        left: left
                    }
                };
                /**
                 * [isSelectedDate description] 是否是被选中日期
                 * @param  {[type]}  date [description]
                 * @return {Boolean}      [description]
                 */
                scope.isSelectedDate = function(date) {
                    if (!(scope.data.selectedDate instanceof Date)) {
                        return false;
                    } else {
                        return date.getFullYear() === scope.data.selectedDate.getFullYear() && date.getMonth() === scope.data.selectedDate.getMonth() && date.getDate() === scope.data.selectedDate.getDate();
                    }
                };
                /**
                 * [selectDate description] 选择日期
                 * @param  {[type]} date [description] 被选择日期
                 * @return {[type]}      [description]
                 */
                scope.selectDate = function(date) {
                    var year = date.getFullYear();
                    var month = date.getMonth();
                    var date = date.getDate();
                    scope.data.selectedDate = scope.data.selectedDate instanceof Date ? scope.data.selectedDate : new Date();
                    scope.data.selectedDate.setFullYear(year);
                    scope.data.selectedDate.setMonth(month);
                    scope.data.selectedDate.setDate(date);
                    //scope.time = $filter("date")(scope.data.selectedDate, "yyyy-MM-dd HH:mm:ss");
                };
                /**
                 * [isToday description] 判断指定日期是否是今天
                 * @param  {[type]}  date [description] 指定日期
                 * @return {Boolean}      [description]
                 */
                scope.isToday = function(date) {
                    return date.getFullYear() === scope.data.today.getFullYear() && date.getMonth() === scope.data.today.getMonth() && date.getDate() === scope.data.today.getDate();
                };
                /**
                 * [switchMonth description] 切换月份
                 * @param  {[type]} monthValue [description] 月份增减量
                 * @return {[type]}            [description]
                 */
                scope.switchMonth = function(monthValue) {
                    var month = scope.data.currentMonth.getMonth();
                    month += monthValue;
                    scope.data.currentMonth.setMonth(month);
                    assembleDateData();
                };
                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.status = {
                        showDatePicker: false
                    };
                    scope.data = {};
                    getTemplate();
                    initBlur();
                    //initMouseWheel();
                    initElementClick();
                    initTimeData();
                    initHoursList();
                    initMinutesList();
                    initSecondsList();
                    initTimeWatch();
                }
                /**
                 * [initTimeWatch description] 监控外部的时间变化
                 * @return {[type]} [description]
                 */
                function initTimeWatch() {
                    scope.$watch("time", function(newV, oldV) {
                        if (newV === oldV) return;
                        var date = new Date(Date.parse(newV));
                        if (date.toDateString() === "Invalid Date") return;
                        scope.data.currentMonth = angular.copy(date);
                        scope.data.selectedDate = angular.copy(date);
                        assembleDateData();
                    })
                }
                /**
                 * [initHoursMouseWheel description] 初始化小时滚动
                 * @return {[type]} [description]
                 */
                function initHoursMouseWheel() {
                    scope.status.template.find(".the_hours .list").bind("mousewheel", function(e) {
                        e.preventDefault();
                        if (e.originalEvent.wheelDelta < 0) {
                            scope.switchHours(1);
                        } else {
                            scope.switchHours(-1);
                        }
                    })
                }
                /**
                 * [initMinutesMouseWheel description] 初始化分钟滚动
                 * @return {[type]} [description]
                 */
                function initMinutesMouseWheel() {
                    scope.status.template.find(".the_minutes .list").bind("mousewheel", function(e) {
                        e.preventDefault();
                        if (e.originalEvent.wheelDelta < 0) {
                            scope.switchMinutes(1);
                        } else {
                            scope.switchMinutes(-1);
                        }
                    })
                }
                /**
                 * [initSecondsMouseWheel description] 初始化秒钟滚动
                 * @return {[type]} [description]
                 */
                function initSecondsMouseWheel() {
                    scope.status.template.find(".the_seconds .list").bind("mousewheel", function(e) {
                        e.preventDefault();
                        if (e.originalEvent.wheelDelta < 0) {
                            scope.switchSeconds(1);
                        } else {
                            scope.switchSeconds(-1);
                        }
                    })
                }
                /**
                 * [selectHour description] 选择小时
                 * @param  {[type]} item [description] 被选择小时
                 * @return {[type]}      [description]
                 */
                scope.selectHour = function(item) {
                    if (!(scope.data.selectedDate instanceof Date)) {
                        return;
                    }
                    scope.data.selectedDate.setHours(item);
                }
                /**
                 * [selectMinute description] 选择分钟
                 * @param  {[type]} item [description] 被选择分钟
                 * @return {[type]}      [description]
                 */
                scope.selectMinute = function(item) {
                    if (!(scope.data.selectedDate instanceof Date)) {
                        return;
                    }
                    scope.data.selectedDate.setMinutes(item);
                }
                /**
                 * [selectMinute description] 选择分钟
                 * @param  {[type]} item [description] 被选择分钟
                 * @return {[type]}      [description]
                 */
                scope.selectSecond = function(item) {
                    if (!(scope.data.selectedDate instanceof Date)) {
                        return;
                    }
                    scope.data.selectedDate.setSeconds(item);
                }
                /**
                 * [confirm description] 确认
                 * @return {[type]} [description]
                 */
                scope.confirm = function() {
                    scope.time = $filter("date")(scope.data.selectedDate, "yyyy-MM-dd HH:mm:ss");
                    scope.status.showDatePicker = false;
                };
                /**
                 * [cancel description] 取消
                 * @return {[type]} [description]
                 */
                scope.cancel = function() {
                    scope.status.showDatePicker = false;
                };
                /**
                 * [isDisabled description] 确认按钮是否可点击
                 * @return {Boolean} [description]
                 */
                scope.isDisabled = function() {
                    return !(scope.data.selectedDate instanceof Date);
                };
                /**
                 * [hoursStyle description] 小时列表选中状态样式
                 * @return {[type]} [description]
                 */
                scope.hoursStyle = function() {
                    if (scope.data.selectedDate instanceof Date) {
                        var hour = scope.data.selectedDate.getHours();
                        return {
                            top: 48 - hour * 24
                        }
                    } else {
                        return {
                            top: 48
                        }
                    }
                };
                /**
                 * [switchHours description] 切换小时
                 * @param  {[type]} value [description]
                 * @return {[type]}       [description]
                 */
                scope.switchHours = function(value) {
                    if (!(scope.data.selectedDate instanceof Date)) {
                        return;
                    }
                    var hour = scope.data.selectedDate.getHours();
                    hour += value;
                    hour = hour < 0 ? 23 : hour;
                    hour = hour > 23 ? 0 : hour;
                    $timeout(function() {
                        scope.data.selectedDate.setHours(hour);
                    });
                };
                /**
                 * [switchMinutes description] 切换分钟
                 * @param  {[type]} value [description]
                 * @return {[type]}       [description]
                 */
                scope.switchMinutes = function(value) {
                    if (!(scope.data.selectedDate instanceof Date)) {
                        return;
                    }
                    var miuntes = scope.data.selectedDate.getMinutes();
                    miuntes += value;
                    miuntes = miuntes < 0 ? 59 : miuntes;
                    miuntes = miuntes > 59 ? 0 : miuntes;
                    $timeout(function() {
                        scope.data.selectedDate.setMinutes(miuntes);
                    });
                };
                /**
                 * [switchSeconds description] 切换分钟
                 * @param  {[type]} value [description]
                 * @return {[type]}       [description]
                 */
                scope.switchSeconds = function(value) {
                    if (!(scope.data.selectedDate instanceof Date)) {
                        return;
                    }
                    var seconds = scope.data.selectedDate.getSeconds();
                    seconds += value;
                    seconds = seconds < 0 ? 59 : seconds;
                    seconds = seconds > 59 ? 0 : seconds;
                    $timeout(function() {
                        scope.data.selectedDate.setSeconds(seconds);
                    });
                };
                /**
                 * [minutesStyle description] 分钟选中状态样式
                 * @return {[type]} [description]
                 */
                scope.minutesStyle = function() {
                    if (scope.data.selectedDate instanceof Date) {
                        var minutes = scope.data.selectedDate.getMinutes();
                        return {
                            top: 48 - minutes * 24
                        }
                    } else {
                        return {
                            top: 48
                        }
                    }
                };
                /**
                 * [secondsStyle description] 秒钟选中状态样式
                 * @return {[type]} [description]
                 */
                scope.secondsStyle = function() {
                    if (scope.data.selectedDate instanceof Date) {
                        var seconds = scope.data.selectedDate.getSeconds();
                        return {
                            top: 48 - seconds * 24
                        }
                    } else {
                        return {
                            top: 48
                        }
                    }
                };
                /**
                 * [initHoursList description] 初始化小时列表
                 * @return {[type]} [description]
                 */
                function initHoursList() {
                    scope.status.hours = [];
                    for (var i = 0; i < 24; i++) {
                        scope.status.hours.push(i);
                    }
                }
                /**
                 * [initMinutesList description] 初始化分钟列表
                 * @return {[type]} [description]
                 */
                function initMinutesList() {
                    scope.status.minutes = [];
                    for (var i = 0; i < 60; i++) {
                        scope.status.minutes.push(i);
                    }
                }
                /**
                 * [initSecondsList description] 初始化秒钟列表
                 * @return {[type]} [description]
                 */
                function initSecondsList() {
                    scope.status.seconds = [];
                    for (var i = 0; i < 60; i++) {
                        scope.status.seconds.push(i);
                    }
                }
                /**
                 * [initTimeData description] 初始化时间数据
                 * @return {[type]} [description]
                 */
                function initTimeData() {
                    var time;
                    try {
                        time = new Date(Date.parse(scope.time));
                        if (time.toDateString() === "Invalid Date") {
                            time = new Date();
                        } else {
                            scope.data.selectedDate = time;
                        }
                    } catch (e) {
                        time = new Date();
                    } finally {
                        scope.data.currentMonth = angular.copy(time);
                        scope.data.currentMonth.setDate(1);
                        scope.data.today = new Date();
                    }
                }
                /**
                 * [assembleDateData description] 组装日期数据
                 * @return {[type]} [description]
                 */
                function assembleDateData(finish) {
                    scope.data.currentMonth.setDate(1);
                    var tempStartTime = angular.copy(scope.data.currentMonth),
                        dateArray = [];
                    assembleCurMonth(function() {
                        tempStartTime = angular.copy(scope.data.currentMonth);
                        fillPrev(function() {
                            tempStartTime = angular.copy(dateArray[dateArray.length - 1]);
                            fillNext(function() {
                                //console.log(dateArray);
                                scope.data.dateArray = dateArray;
                                if (typeof finish === "function") finish();
                            });
                        });
                    });
                    /**
                     * [fillPrev description] 补全前面数据
                     * @return {[type]} [description]
                     */
                    function fillPrev(finish) {
                        var day = tempStartTime.getDay();
                        if (day === 0) {
                            finish();
                        } else {
                            var date = tempStartTime.getDate();
                            tempStartTime.setDate(--date);
                            dateArray.unshift(angular.copy(tempStartTime));
                            fillPrev(finish);
                        }
                    }
                    /**
                     * [fillNext description] 补全后面数据
                     * @param  {[type]} finish [description]
                     * @return {[type]}        [description]
                     */
                    function fillNext(finish) {
                        var day = tempStartTime.getDay();
                        if (day === 6) {
                            finish();
                        } else {
                            var date = tempStartTime.getDate();
                            tempStartTime.setDate(++date);
                            dateArray.push(angular.copy(tempStartTime));
                            fillNext(finish);
                        }
                    }
                    /**
                     * [assembleCurMonth description] 组装本月数据
                     * @return {[type]} [description]
                     */
                    function assembleCurMonth(finish) {
                        if (tempStartTime.getMonth() === scope.data.currentMonth.getMonth()) {
                            var date = tempStartTime.getDate();
                            dateArray.push(angular.copy(tempStartTime));
                            tempStartTime.setDate(++date);
                            assembleCurMonth(finish);
                        } else {
                            finish();
                        }
                    }
                }
                /**
                 * [initMouseWheel description] 初始化鼠标滚动消失事件
                 * @return {[type]} [description]
                 */
                function initMouseWheel() {
                    window.addEventListener("mousewheel", mousewheel);
                    scope.$on("$destroy", function() {
                        window.removeEventListener("mousewheel", mousewheel);
                    });

                    function mousewheel() {
                        $timeout(function() {
                            scope.status.showDatePicker = false;
                        });
                    }
                }
                /**
                 * [initElementClick description] 初始化主元素的点击事件
                 * @return {[type]} [description]
                 */
                function initElementClick() {
                    $element.attr("readonly", true);
                    $element.bind("click", function() {
                        if (!scope.status.showDatePicker) {
                            assembleDateData(function() {
                                scope.status.showDatePicker = true;
                            });
                        } else {
                            scope.status.showDatePicker = false;
                        }
                    });
                }
                /**
                 * [initElementEvent description] 初始化聚焦失焦事件
                 * @return {[type]} [description]
                 */
                function initBlur() {
                    var blur = function(e) {
                        var $target = $(e.target);
                        if ($target[0] !== $element[0] && $target[0] !== scope.status.template[0] && $target.parents(".precise_time_picker")[0] !== scope.status.template[0]) {
                            scope.status.showDatePicker = false;
                        }
                    }
                    $("body").bind("mouseup", blur);
                    scope.$on("$destroy", function() {
                        $("body").unbind("mouseup", blur);
                    });
                }
                /**
                 * [initData description] 初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {

                }
                /**
                 * [getTemplate description] 获取模板
                 * @return {[type]} [description]
                 */
                function getTemplate() {
                    $templateRequest("./components/util/preciseTimePicker/preciseTimePicker_tpl.html").then(function(template) {
                        scope.status.template = $compile(template)(scope);
                        $("body").append(scope.status.template);
                        initHoursMouseWheel();
                        initMinutesMouseWheel();
                        initSecondsMouseWheel();
                    });
                };
            }
        }
    }]);